<template>
  <section class="about-section" v-if="country">
    <div class="container">
      <div class="main-card">
        <div class="overview">
          <h2 class="main-title">About {{ country.name }}</h2>
          <p class="intro-text">{{ country.intro }}</p>
        </div>

        <hr class="separator" />

        <div v-for="(detail, key) in country.details" :key="key" class="indicator-detail">
          <div class="title-row">
            <h3 class="indicator-title">{{ detail.title }}</h3>
          </div>
          <p class="detail-text">{{ detail.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ['country']
}
</script>

<style scoped>
.about-section {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 40px 0;
}

.container {
  width: 100%;
  padding: 0 80px;
  text-align: left;
}

.main-card {
  background: #ffffff;
  padding: 50px;
  border-radius: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  width: 90%;
  min-width: 320px;
  text-align: left;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 20px;
  color: #003399; /* javítva */
  text-align: left;
}

.intro-text {
  width: 100%;
  text-align: left;
  font-size: 1.15rem;
  line-height: 1.7;
  color: #004444; /* javítva */
  margin-bottom: 30px;
}

.indicator-title {
  color: #003399; /* javítva */
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 12px;
  text-align: left;
}

.detail-text {
  width: 100%;
  text-align: left;
  font-size: 1.1rem;
  line-height: 1.7;
  color: #004444; /* javítva */
  margin-bottom: 30px;
}

.indicator-detail {
  margin-bottom: 40px;
  text-align: left;
}

.title-row {
  margin-bottom: 10px;
  text-align: left;
}

.separator {
  border: 0;
  border-top: 1px solid #d1e1e0; /* javítva */
  margin: 40px 0;
  width: 100%;
}

@media (max-width: 1024px) {
  .container {
    padding: 0 40px;
  }
  .main-card {
    width: 90%;
  }
}

@media (max-width: 768px) {
  .main-card {
    width: 100%;
    padding: 30px;
  }
}
</style>
